import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import reportWebVitals from "./reportWebVitals";
import { WebVitals } from "./hooks/Logger";

// Analytics se inicializa solo tras consentimiento (ver CookieConsentContext)

const rootEl = document.getElementById("root");
try {
	const root = ReactDOM.createRoot(rootEl);
	root.render(
		<React.StrictMode>
			<ErrorBoundary>
				<WebVitals />
				<App />
			</ErrorBoundary>
		</React.StrictMode>,
	);
} catch (err) {
	if (typeof console !== "undefined") {
		console.error("No se pudo montar la app", err);
	}
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
